var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.elementDOM,{ref:_vm.refName,tag:"div",attrs:{"data-name":_vm.slotName,"aria-label":_vm.label,"role":_vm.role}},[(!_vm.isBuildWc)?[_c('div',{staticClass:"webcomponent webcomponent-simulator",class:_vm.wrapperClass},[(_vm.slotName)?_vm._t(_vm.slotName):_vm._t("default")],2)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }